import React from 'react'
import '../../../styles/containers/Prayer/components/god-card.scss';
function GodCard({god, godSelected}) {
    return (
        <div className={`god-card-container d-flex justify-content-center align-items-center ${godSelected?'god-selected':''}`}>
            <img className='god-image' src={god.image} alt={god.key}></img>            
        </div>
    )
}

export default GodCard